module.exports = __webpack_public_path__ + "static/media/loading.bfd2865e.lottie";